export const roles = [
  "Super Admin",
  "Admin",
  "Admin HR",
  "Admin Finance",
  "Field Agent",
  "R&D",
  "Marketing",
  "Mitra",
];
